import { Container, Form, Alert} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper, Button} from "../ContentStyles";
import useBackend, {CallAPI, Loading, Spinner, UserData} from '../../services/useBackend';
import React, { useState ,useEffect, useReducer, fetchData,useMemo} from 'react';
import {DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO, getOptions, metaLookUpTitle} from '../../services/misc';

function MyData() {
    const [resultText, setResultText] = useState("N/A");
    const [resultVariant, setResultVariant] = useState("success");
    const [resultVisible, setResultVisible] = useState(false);
    const [spinnerHidden, setSpinnerHidden] = useState(true);    

    const {IsLoggedIn, token}      = UserData();

    async function handleSubmit(e) {
        e.preventDefault();
        setSpinnerHidden(false);

        const formData = new FormData(e.target),
        formDataObj = Object.fromEntries(formData.entries())

        let {resultVariant, errorsException, resultVisible, resultText, jsondata} = await CallAPI('/api/user','PATCH',JSON.stringify(formDataObj));


        localStorage.setItem('access_token', jsondata.access_token);
        setResultVariant(resultVariant);      
        setResultText(resultText);        
        setSpinnerHidden(true);
        setResultVisible(resultVisible);
    }   

    return (
        <ContentWrapper>
                <Sida>
                <Rubrik>Mina Sidor</Rubrik>

                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" name="Email" placeholder="Email" id="name" defaultValue={token.emailaddress}/>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Personnummer</Form.Label>
                        <Form.Control type="text" name="personalNumber" placeholder="Personnummer" id="personalNumber" defaultValue={token.personalNumber} disabled/>
                    </Form.Group>                            

                    <Form.Group className="mb-3" >
                        <Form.Label>Namn</Form.Label>
                        <Form.Control type="text" name="name" placeholder="Name" id="name" defaultValue={token.name} />
                    </Form.Group>

                    <Form.Group className="mb-3" >
                        <Form.Label>Telefon</Form.Label>
                        <Form.Control type="text" name="phone" placeholder="Phone" id="phone"  defaultValue={token.mobilephone}/>
                    </Form.Group> 

                    <Form.Group className="mb-3" >
                        <Form.Label>Startsida</Form.Label>
                        <Form.Select type="text" name="startpage" placeholder="Startsida" id="startpage"  defaultValue={token.startpage}>
                                    <option value="/mypage">Mina Sidor</option>
                                    <option value="/cities">Städer</option>
                                    <option value="/">Start</option>
                        </Form.Select>
                    </Form.Group>                                                                      

                    <Form.Group className="mb-3"  hidden={spinnerHidden}>
                        <Spinner  />
                    </Form.Group>                     

                    <Form.Group className="mb-3"  hidden={!resultVisible}>
                        <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert> 
                    </Form.Group>        

                    <Form.Group className="mb-3">
                        <Button className="QmeButton" variant="primary" type="submit">Spara</Button>
                    </Form.Group>    
                </Form>      
            </Sida>
        </ContentWrapper>
    );   
}

export default MyData;